export default __webpack_public_path__ + "static/design-illustration-hero-1fee323a04042414ccf04c93307996f3.svg";